import { render, staticRenderFns } from "./DriverPendingTransactions.vue?vue&type=template&id=4475e8c7&scoped=true&"
import script from "./DriverPendingTransactions.vue?vue&type=script&lang=js&"
export * from "./DriverPendingTransactions.vue?vue&type=script&lang=js&"
import style0 from "./DriverPendingTransactions.vue?vue&type=style&index=0&id=4475e8c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4475e8c7",
  null
  
)

export default component.exports